export enum TicketStatus{
  open='Open',
  close='Close'
}
